import { render, staticRenderFns } from "./ShowPlanThumb.vue?vue&type=template&id=49b43715&scoped=true"
import script from "./ShowPlanThumb.vue?vue&type=script&lang=js"
export * from "./ShowPlanThumb.vue?vue&type=script&lang=js"
import style0 from "./ShowPlanThumb.vue?vue&type=style&index=0&id=49b43715&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b43715",
  null
  
)

export default component.exports